import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import { delay } from '../../../Utility/Task/TaskQueue';
import SpriteComponent from '../../../Component/Render/Sprite';
import { Easing } from '@tweenjs/tween.js';
import TransformComponent from '../../../Component/Transform';

export class ChestOpen extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);
        transform.position.set(0, 0);
        transform.scale.set(1, 1);

        const spriteComponent = gameObject.getComponent(SpriteComponent);

        spriteComponent.texture = 'chest_open';
        spriteComponent.anchor.x = 0.4;

        yield* delay(2500);

        const scaleTween = this.getTween(
            gameObject.parent.getComponent(TransformComponent).scale
        );
        scaleTween.to({ x: 0.01, y: 0.01 }, 250);
        scaleTween.easing(Easing.Back.In);
        scaleTween.start(this.elapsedTime);

        yield* delay(500);

        gameObject.parent.destroy();
    }
}
